module.exports = __webpack_public_path__ + "img/icon_right.7113f5ea.svg";